import React, { FC } from "react"
import { FormattedMessage } from "react-intl"
import { Button, Divider, Typography, useTheme, Stack } from "@carrotfertility/carotene-core"
import { Link as RouterLink } from "react-router-dom"

const ModalErrorStep: FC = () => {
  const theme = useTheme()
  return (
    <Stack padding={theme.spacing(theme.tokens.spacing.xxxl)} spacing={theme.spacing(theme.tokens.spacing.md)}>
      <Typography variant="h2" align="center">
        <FormattedMessage defaultMessage="An unknown error occurred." />
      </Typography>
      <Typography align="center">
        <FormattedMessage defaultMessage="Please refresh the page and try again." />
      </Typography>
      <Divider />
      <Stack direction="row" spacing={theme.spacing(theme.tokens.spacing.md)}>
        <Button onClick={() => window.location.reload()}>
          <FormattedMessage defaultMessage="Refresh the page" />
        </Button>
        <Button to="/" id="home" component={RouterLink} variant="outlined">
          <FormattedMessage defaultMessage="Carrot Home" />
        </Button>
      </Stack>
    </Stack>
  )
}

export { ModalErrorStep }
